import React from "react";

import { RouterLink } from "@examspark/common-ui";
import { CardLink } from "@examspark/common-ui/dist/components/containers/LinkCard";
import { IconStarLine } from "@examspark/common-ui/dist/components/icons";
import { Resource } from "@examspark/types";

import { getUrlForObject } from "../../utils";
import { SidebarLinkItem } from "../classroom/sidebar/BasicSidebarListItem";
import SidebarBox, { EmptySidebarBox } from "../common/SidebarBox";

type FavoriteResource = Resource & { favoriteUrl: string };

const DashboardFavorites = ({ favorites }: { favorites?: Resource[] }) => {
  const favoritesWithUrls = favorites
    ?.map(
      (favorite) =>
        ({
          ...favorite,
          favoriteUrl: getUrlForObject(favorite),
        }) as FavoriteResource,
    )
    .filter((favorite) => favorite.favoriteUrl);

  return (
    <SidebarBox
      title="Favorites"
      toolbar={<RouterLink to="/favorites">See All</RouterLink>}
    >
      {favoritesWithUrls?.length === 0 && (
        <EmptySidebarBox>
          <IconStarLine />
          <div>You don't have any favorites yet.</div>
        </EmptySidebarBox>
      )}
      {favoritesWithUrls?.map((favorite) => {
        return (
          <SidebarLinkItem key={favorite.id}>
            <CardLink to={favorite.favoriteUrl}>{favorite.name}</CardLink>
          </SidebarLinkItem>
        );
      })}
    </SidebarBox>
  );
};

export default DashboardFavorites;
